<template lang="html">
  <div class="app-sidebar colored">
    <div class="sidebar-header">
      <router-link
        class="header-brand"
        href="#"
        :to="{name: 'home'}">
        <div class="logo-img">
          <img
            src="/static/images/logo_small.png"
            class="header-brand-img"
            alt="Api4Com - API de VOZ integrado com seu CRM">
        </div>
        <span class="text">
          <img
            src="/static/images/logo_only_name.png"
            class="header-brand-name-img"
            alt="Api4Com - API de VOZ integrado com seu CRM">
        </span>
      </router-link>
      <button
        type="button"
        class="nav-toggle">
        <i
          data-toggle="expanded"
          class="ik ik-toggle-right toggle-icon" />
      </button>
      <button
        id="sidebarClose"
        class="nav-close"><i class="ik ik-x" /></button>
    </div>
    <div class="sidebar-content">
      <div class="nav-container">
        <nav
          id="main-menu-navigation"
          class="navigation-main">
          <div class="nav-item dashboard active">
            <router-link
              title="Dashboard"
              href="#"
              :to="{name: 'dashboard'}">
              <i class="ik ik-bar-chart-2" /><span>Dashboard</span>
            </router-link>
          </div>
          <div class="nav-item">
            <a
              title="Webphone"
              href="#"
              @click.prevent="openTutorialWebphone">
              <i class="ik ik-chrome" /><span>1 - Webphone</span>
            </a>
          </div>
          <div class="nav-item integrationManager">
            <router-link
              title="Integrações"
              href="#"
              :to="{name: 'integrationManager'}">
              <i class="ik ik-share-2" /><span>2 - Integrações</span>
            </router-link>
          </div>
          <div class="nav-item accessTokens">
            <router-link
              title="Tokens de acesso"
              href="#"
              :to="{name: 'accessTokens'}">
              <i class="ik ik-lock" /><span>3 - Tokens de acesso</span>
            </router-link>
          </div>
          <div class="nav-item">
            <a
              title="Google Data Studio"
              href="#"
              @click.prevent="openTutorialGoogleDataStudio">
              <i class="ik ik-database" /><span>4 - Google Data Studio</span>
            </a>
          </div>
          <div class="nav-item reportCalls">
            <router-link
              title="Relatório de Chamadas"
              href="#"
              class="menu-item"
              :to="{name: 'reportCalls'}">
              <i class="ik ik-file-text" /><span>5 - Relatório de Chamadas</span>
            </router-link>
          </div>
          <div v-if="isRolloutAutomaticRecharge">
            <div
              class="nav-item has-sub chargeHistory"
              v-if="isAdmin">
              <a
                title="Créditos"
                href="#">
                <i class="ik ik-dollar-sign" /><span>6 - Créditos</span>
              </a>
              <div class="submenu-content chargeHistory">
                <router-link
                  class="menu-item"
                  title="Histórico de Recargas"
                  href="#"
                  :to="{name: 'chargeHistory'}">
                  <span>6.1 - Histórico de Recargas</span>
                </router-link>
              </div>
              <div class="submenu-content automaticRecharge">
                <router-link
                  class="menu-item"
                  title="Recarga Automática"
                  href="#"
                  :to="{name: 'automaticRecharge'}">
                  <span>6.2 - Recarga Automática</span>
                </router-link>
              </div>
            </div>
          </div>
          <div v-else>
            <div
              class="nav-item chargeHistory"
              v-if="isAdmin">
              <router-link
                title="Créditos"
                href="#"
                :to="{name: 'chargeHistory'}">
                <i class="ik ik-dollar-sign" /><span>6 - Recargas</span>
              </router-link>
            </div>
          </div>
          <div
            class="nav-item financialData"
            v-if="isAdmin">
            <router-link
              title="Dados Financeiros"
              :to="{name: 'financialData'}">
              <i class="ik ik-dollar-sign" /><span>7 - Dados Financeiros</span>
            </router-link>
          </div>
          <div
            class="nav-item usersList"
            v-if="isAdmin">
            <router-link
              title="Usuários da Organização"
              :to="{name: 'usersList'}">
              <i class="ik ik-users" /><span>8 - Usuários da Organização</span>
            </router-link>
          </div>
          <div
            class="nav-item organizationProfile"
            v-if="isAdmin">
            <router-link
              title="Dados da Organização"
              :to="{name: 'organizationProfile'}">
              <i class="ik ik-home" /><span>9 - Dados da Organização</span>
            </router-link>
          </div>
          <div class="nav-item extensionList extensionEdit">
            <router-link
              title="Ramais"
              href="#"
              :to="{name: 'extensionList'}">
              <i class="ik ik-phone-call" /><span>10 - Ramais</span>
            </router-link>
          </div>
          <div class="nav-item userProfile">
            <router-link
              title="Meus dados"
              :to="{name: 'userProfile'}">
              <i class="ik ik-user" /><span>11 - Meus dados</span>
            </router-link>
          </div>
          <div class="nav-item profile">
            <router-link
              title="Alterar senha"
              :to="{name: 'changePassword'}">
              <i class="ik ik-edit" /><span>12 - Alterar senha</span>
            </router-link>
          </div>
          <div class="nav-item support">
            <a
              title="Suporte"
              href="https://wa.me/554833328503"
              target="_blank">
              <svg
                class="icon"
                xmlns="http://www.w3.org/2000/svg"
                fill="#bcc8d8"
                viewBox="0 0 22 22"
                width="22px"
                height="22px">
                <path d="M 12.011719 2 C 6.5057187 2 2.0234844 6.478375 2.0214844 11.984375 C 2.0204844 13.744375 2.4814687 15.462563 3.3554688 16.976562 L 2 22 L 7.2324219 20.763672 C 8.6914219 21.559672 10.333859 21.977516 12.005859 21.978516 L 12.009766 21.978516 C 17.514766 21.978516 21.995047 17.499141 21.998047 11.994141 C 22.000047 9.3251406 20.962172 6.8157344 19.076172 4.9277344 C 17.190172 3.0407344 14.683719 2.001 12.011719 2 z M 12.009766 4 C 14.145766 4.001 16.153109 4.8337969 17.662109 6.3417969 C 19.171109 7.8517969 20.000047 9.8581875 19.998047 11.992188 C 19.996047 16.396187 16.413812 19.978516 12.007812 19.978516 C 10.674812 19.977516 9.3544062 19.642812 8.1914062 19.007812 L 7.5175781 18.640625 L 6.7734375 18.816406 L 4.8046875 19.28125 L 5.2851562 17.496094 L 5.5019531 16.695312 L 5.0878906 15.976562 C 4.3898906 14.768562 4.0204844 13.387375 4.0214844 11.984375 C 4.0234844 7.582375 7.6067656 4 12.009766 4 z M 8.4765625 7.375 C 8.3095625 7.375 8.0395469 7.4375 7.8105469 7.6875 C 7.5815469 7.9365 6.9355469 8.5395781 6.9355469 9.7675781 C 6.9355469 10.995578 7.8300781 12.182609 7.9550781 12.349609 C 8.0790781 12.515609 9.68175 15.115234 12.21875 16.115234 C 14.32675 16.946234 14.754891 16.782234 15.212891 16.740234 C 15.670891 16.699234 16.690438 16.137687 16.898438 15.554688 C 17.106437 14.971687 17.106922 14.470187 17.044922 14.367188 C 16.982922 14.263188 16.816406 14.201172 16.566406 14.076172 C 16.317406 13.951172 15.090328 13.348625 14.861328 13.265625 C 14.632328 13.182625 14.464828 13.140625 14.298828 13.390625 C 14.132828 13.640625 13.655766 14.201187 13.509766 14.367188 C 13.363766 14.534188 13.21875 14.556641 12.96875 14.431641 C 12.71875 14.305641 11.914938 14.041406 10.960938 13.191406 C 10.218937 12.530406 9.7182656 11.714844 9.5722656 11.464844 C 9.4272656 11.215844 9.5585938 11.079078 9.6835938 10.955078 C 9.7955938 10.843078 9.9316406 10.663578 10.056641 10.517578 C 10.180641 10.371578 10.223641 10.267562 10.306641 10.101562 C 10.389641 9.9355625 10.347156 9.7890625 10.285156 9.6640625 C 10.223156 9.5390625 9.737625 8.3065 9.515625 7.8125 C 9.328625 7.3975 9.131125 7.3878594 8.953125 7.3808594 C 8.808125 7.3748594 8.6425625 7.375 8.4765625 7.375 z"/>
              </svg>
              <span>13 - Suporte</span>
            </a>
          </div>
          <div class="nav-item">
            <a
              title="Sair"
              href="#"
              @click="onLogoutClick">
              <i class="ik ik-power" /><span>Sair</span>
            </a>
          </div>
        </nav>
      </div>
    </div>
  </div>
</template>

<script>
import loopback from '@/services/loopback'

export default {
  name: 'MenuSidebar',
  data () {
    return {
      isRolloutAutomaticRecharge: false
    }
  },
  mounted () {
    this.$nextTick(function () {
      this.loadRolloutAutomaticRecharge()

      function closeSubmenu (e) {
        e.removeClass('open')
      }
      function openSubmenu (e) {
        e.addClass('open')
      }
      function enableMenuCollapsed (element, wrapper) {
        wrapper.addClass('nav-collapsed nav-expanded')
        $('.nav-toggle').find('.toggle-icon').removeClass('ik-toggle-right').addClass('ik-toggle-left')
        element.attr('data-toggle', 'collapsed')
      }
      function disableMenuCollapsed (element, wrapper) {
        wrapper.removeClass('nav-collapsed menu-collapsed nav-expanded')
        $('.nav-toggle').find('.toggle-icon').removeClass('ik-toggle-left').addClass('ik-toggle-right')
        element.attr('data-toggle', 'expanded')
      }
      const sidebar = $('.app-sidebar')
      const menus = $('.sidebar-content')
      const wrapper = $('.wrapper')
      menus.on('click', '.navigation-main .nav-item a', function () {
        const e = $(this).parent('.nav-item')
        if (e.hasClass('has-sub') && e.hasClass('open')) closeSubmenu(e)
        else {
          if (e.hasClass('has-sub')) {
            openSubmenu(e)
            if (menus.data('collapsible')) return !1
            closeSubmenu(e.siblings('.open'))
            e.siblings('.open').find('.nav-item.open').removeClass('open')
          }
        }
      })
      $('.nav-toggle').on('click', (event) => {
        const toggleIcon = $(event.currentTarget).find('.toggle-icon')
        if (toggleIcon.attr('data-toggle') === 'expanded') {
          enableMenuCollapsed(toggleIcon, wrapper)
        } else {
          disableMenuCollapsed(toggleIcon, wrapper)
        }

        const isCollapsed = wrapper.hasClass('nav-collapsed')

        if (isCollapsed) {
          wrapper.addClass('nav-expanded')
          this.$root.$emit('sidebar-hover', true)
        } else {
          wrapper.removeClass('nav-expanded')
        }

        this.$root.$emit('sidebar-toggle', isCollapsed)
      })
      sidebar.on('mouseenter', () => {
        if (wrapper.hasClass('nav-collapsed')) {
          wrapper.removeClass('menu-collapsed')
          menus.find('.nav-item.active').parents('.nav-item').addClass('open')
          $('.navigation-main .nav-item.nav-collapsed-open').addClass('open').removeClass('nav-collapsed-open')
          this.handleSidebarHover(true)
        }
      }).on('mouseleave', () => {
        if (wrapper.hasClass('nav-collapsed')) {
          wrapper.addClass('menu-collapsed')
          $('.navigation-main .nav-item.open').addClass('nav-collapsed-open').removeClass('open')
          this.handleSidebarHover(false)
        }
      })
      if ($(window).width() < 992) {
        sidebar.addClass('hide-sidebar')
        wrapper.removeClass('nav-collapsed menu-collapsed')
      }
      $(window).resize(function () {
        if ($(window).width() < 992) {
          sidebar.addClass('hide-sidebar')
          wrapper.removeClass('nav-collapsed menu-collapsed')
        } else {
          sidebar.removeClass('hide-sidebar')
          if ($('.toggle-icon').attr('data-toggle') === 'collapsed' && wrapper.not('.nav-collapsed menu-collapsed')) {
            wrapper.addClass('nav-collapsed menu-collapsed')
          }
        }
      })
      $(document).on('click', '.navigation li:not(.has-sub)', function () {
        if ($(window).width() < 992) sidebar.addClass('hide-sidebar')
      })
      $(document).on('click', '.logo-text', function () {
        if ($(window).width() < 992) sidebar.addClass('hide-sidebar')
      })
      $('.mobile-nav-toggle').on('click', function (e) {
        e.stopPropagation()
        sidebar.toggleClass('hide-sidebar')
      })
      $('html').on('click', function (s) {
        if ($(window).width() < 992) {
          if (!sidebar.hasClass('hide-sidebar') && sidebar.has(s.target).length === 0) {
            sidebar.addClass('hide-sidebar')
          }
        }
      })
      $('#sidebarClose').on('click', function () {
        sidebar.addClass('hide-sidebar')
      })
      $('[data-toggle="tooltip"]').tooltip()
    })
  },
  methods: {
    onLogoutClick () {
      this
        .$store
        .dispatch('auth/signOut')
      localStorage.removeItem('financialData')
    },
    openTutorialGoogleDataStudio () {
      this.$emit('open-tutorial-google-datastudio')
    },
    openTutorialWebphone () {
      this.$emit('open-tutorial-webphone')
    },
    loadRolloutAutomaticRecharge () {
      if (this.$store.state.auth.user && this.$store.state.auth.user.role === 'ADMIN') {
        loopback
          .get('/rollout?featureFlag=automatic-recharge')
          .then(rollout => {
            this.isRolloutAutomaticRecharge = rollout === 'ALLOWED'
          })
      }
    },
    handleSidebarHover (isHovered) {
      if (isHovered) {
        if (document.querySelector('.wrapper').classList.contains('nav-collapsed')) {
          document.querySelector('.wrapper').classList.remove('menu-collapsed')
          this.$root.$emit('sidebar-hover', true)
        }
      } else {
        if (document.querySelector('.wrapper').classList.contains('nav-collapsed')) {
          document.querySelector('.wrapper').classList.add('menu-collapsed')
          this.$root.$emit('sidebar-hover', false)
        }
      }
    }
  },
  computed: {
    isAdmin () {
      return this.$store.state.auth.user && this.$store.state.auth.user.role === 'ADMIN'
    }
  },
  watch: {
    '$route' (to, from) {
      if (this.$route.matched[0]) {
        $(`#main-menu-navigation .active:not(.${this.$route.matched[0].name})`).removeClass('active')
        $(`.${this.$route.matched[0].name}`).addClass('active')
        if ($(`.${this.$route.matched[0].name}`).parent('.nav-item').hasClass('has-sub')) {
          $(`.${this.$route.matched[0].name}`).parent('.nav-item').addClass('open')
        } else {
          $('.nav-item.has-sub').removeClass('open')
        }
      }
    }
  }
}
</script>

<style lang="scss" scoped>
.header-brand-img {
  width: 26px;
  height: 26px;
}
.header-brand-name-img {
  width: 150px;
  height: 26px;
}
.icon {
  margin-right: 5px;
  display: inline-block;
  vertical-align: -4px;
}
.submenu-content.active a.menu-item span {
  color: #eb525d !important;
}
</style>



// WEBPACK FOOTER //
// src/components/Container/MenuSidebar.vue